export class RoomChat {
    username?: string;
    fullname?: string;
    sessionID?: string;
    peerJid?: string;
    joined?: boolean;
    timeJoin?: number;
    timeLeft?: number;
    timereg?: number;
    message?: string;

    constructor(options: any) {
        Object.assign(this, options);
    }

    get isJoined(): boolean {
        return !!this.joined && !!this.peerJid && !!this.sessionID;
    }

    get isLeft(): boolean {
        return !!this.joined  && !!this.timeLeft;
    }
}
